<script setup lang="ts">
import IconButton from '~/components/IconButton.vue';
import { generateEntityId } from '~/common/types/helpers';
import type { Client, Search } from "~/common/types/types";
import CreateSearchModal from './CreateSearchModal.vue';
import { useSearchStore } from '~/store';
const store = useSearchStore();
const isModalOpen = ref(false);

const props = defineProps({
  client: {
    type: Object as PropType<Client>,
    required: true,
  },
});

const search = ref();
const buildDefaultSearch = (): Search => ({
  _id: generateEntityId(),
  clientId: props.client._id,
  name: "",
  status: "pending",
  description: "",
  results: [],
  threshold: 40,
  created: new Date(),
  updated: new Date()
});
function startNew() {
  search.value = buildDefaultSearch();
  isModalOpen.value = true;
}

</script>

<template>
    <span><IconButton @click="startNew" 
        type="add"
        size="sm"
        color="primary"
        square
        variant="link"
        title="Create New"></IconButton>
        <CreateSearchModal
            v-if="isModalOpen"
            v-model="search"
            @close="isModalOpen = false"
            @submitted="(search: Search) => store.addSearch(search)"
        />
    </span>
</template>